/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ACSBaseService } from '../acs-base-service';
import { ACSApiConfiguration } from '../acs-api-configuration';
import { ACSStrictHttpResponse } from '../acs-strict-http-response';

import { NextCallerResponseModel } from '../models/next-caller-response-model';
import { practitionerAvailablePut } from '../fn/practitioner/practitioner-available-put';
import { PractitionerAvailablePut$Params } from '../fn/practitioner/practitioner-available-put';
import { practitionerLeaveDelete } from '../fn/practitioner/practitioner-leave-delete';
import { PractitionerLeaveDelete$Params } from '../fn/practitioner/practitioner-leave-delete';
import { practitionerNextCallerGet } from '../fn/practitioner/practitioner-next-caller-get';
import { PractitionerNextCallerGet$Params } from '../fn/practitioner/practitioner-next-caller-get';
import { QueueStatusModel } from '../models/queue-status-model';

@Injectable({ providedIn: 'root' })
export class ACSPractitionerService extends ACSBaseService {
  constructor(config: ACSApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `practitionerAvailablePut()` */
  static readonly PractitionerAvailablePutPath = '/Practitioner/Available';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerAvailablePut()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerAvailablePut$Response(params?: PractitionerAvailablePut$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<QueueStatusModel>> {
    return practitionerAvailablePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerAvailablePut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerAvailablePut(params?: PractitionerAvailablePut$Params, context?: HttpContext): Observable<QueueStatusModel> {
    return this.practitionerAvailablePut$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<QueueStatusModel>): QueueStatusModel => r.body)
    );
  }

  /** Path part for operation `practitionerLeaveDelete()` */
  static readonly PractitionerLeaveDeletePath = '/Practitioner/Leave';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerLeaveDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerLeaveDelete$Response(params?: PractitionerLeaveDelete$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
    return practitionerLeaveDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerLeaveDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerLeaveDelete(params?: PractitionerLeaveDelete$Params, context?: HttpContext): Observable<void> {
    return this.practitionerLeaveDelete$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerNextCallerGet()` */
  static readonly PractitionerNextCallerGetPath = '/Practitioner/NextCaller';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerNextCallerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerNextCallerGet$Response(params?: PractitionerNextCallerGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<NextCallerResponseModel>> {
    return practitionerNextCallerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerNextCallerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerNextCallerGet(params?: PractitionerNextCallerGet$Params, context?: HttpContext): Observable<NextCallerResponseModel> {
    return this.practitionerNextCallerGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<NextCallerResponseModel>): NextCallerResponseModel => r.body)
    );
  }

}
